import { forwardRef } from 'react';
// import { useTranslation } from 'react-i18next';

import FilesInline from 'components/Inputs/inline/Files';
import { withCellWrapper } from './helpers';

const _FilesCell = forwardRef(
  (
    {
      field,
      entityId,
      entityAccess,
      onSubmit,
      value,
      objectId,
      serviceToUse,
      fetchUrl,
      handleUpdateFieldOption,
      handleUpdateTableRecords,
      menuLeftButton,
      menuRightButton,
      placeholder,
      info,
      showDisplayNameTooltip,
      column,
      readOnly,
      onAutoFocus,
      viewable,
      ...others
    },
    ref
  ) => {
    return (
      <FilesInline
        ref={ref}
        {...others}
        field={field}
        entityId={entityId}
        disabled={readOnly}
        viewable={viewable}
        value={value}
        onSubmit={onSubmit}
        onAutoFocus={onAutoFocus}
      />
    );
  }
);

export const FilesCell = withCellWrapper(_FilesCell);
